import { fetchLoggedInUserDetails } from '../api/loginApi';
import { creators as userCreators } from '../ducks/userDuck';
import { logoutAction } from './auth';

export const fetchUserAction = token => async (dispatch, _getState) => {
  dispatch(userCreators.fetch());
  try {
    const response = await fetchLoggedInUserDetails({
      token,
    });
    dispatch(userCreators.fetchSuccess(response));
  } catch (error) {
    dispatch(logoutAction());
    dispatch(userCreators.fetchFailed(error));
    throw error;
  }
};
